import { Component, Input, OnInit, ViewChild } from '@angular/core';
import {
  UntypedFormBuilder,
  UntypedFormGroup,
  UntypedFormControl,
  Validators,
} from '@angular/forms';
import {
  ActionSheetController,
  AlertController,
  NavParams,
  LoadingController,
  ModalController
} from '@ionic/angular';

import { Client } from '../../models';
import { Salon } from '../../models';
import { Country } from '../../models';
import { ClientService } from '../../services/client.service';
import { UserService } from '../../services/user.service';
import { SalonService } from '../../services/salon.service';
import { CountryService } from '../../services/country.service';
import { CustomValidator } from '../../utilities/custom-validator';
import { ClientEmailChecker } from '../../utilities/client-email-checker';
import { Utilities } from '../../utilities/utilities';
import { List } from 'immutable';
import { ActivatedRoute } from '@angular/router';
export interface IClientMergeFormCallBackData {
  client: Client;
  action: string;
}
@Component({
  selector: 'smr-client-merge',
  templateUrl: './client-merge.component.html',
  styleUrls: ['./client-merge.component.scss'],
})
export class ClientMergeComponent implements OnInit {
  @Input() client: Client;
  @Input() mergeFrom: Client;
  public modal: boolean;

  public isLoading: boolean;

  public submitAttempt: boolean;

  public salon: Salon;
  // public client: Client;

  // public mergeFrom: Client;

  public clientForm: UntypedFormGroup;

  public firstName: UntypedFormControl;

  public lastName: UntypedFormControl;ƒ

  public email: UntypedFormControl;

  public phone1: UntypedFormControl;

  public phone2: UntypedFormControl;

  public workPh: UntypedFormControl;

  public address1: UntypedFormControl;

  public address2: UntypedFormControl;

  public city: UntypedFormControl;

  public province: UntypedFormControl;

  public postal: UntypedFormControl;

  public notes: UntypedFormControl;

  public mergeFromFirstName: string;

  public mergeFromLastName: string;

  public mergeFromEmail: string;

  public mergeFromPhone1: string;

  public mergeFromPhone2: string;

  public mergeFromWorkPh: string;

  public mergeFromAddress1: string;

  public mergeFromAddress2: string;

  public mergeFromCity: string;

  public mergeFromProvince: string;

  public mergeFromPostal: string;

  public mergeFromNotes: string;

  public swapTemp: string;

  constructor(
    private navParams: NavParams,
    private alertCtrl: AlertController,
    private actionsheetCtrl: ActionSheetController,
    private clientService: ClientService,
    private userService: UserService,
    private countryService: CountryService,
    private salonService: SalonService,
    private formBuilder: UntypedFormBuilder,
    private loadingCtrl: LoadingController,
    private clientEmailChecker: ClientEmailChecker,
    private route: ActivatedRoute,
    private modalCtrl: ModalController
  ) {
    // this.route.params.subscribe({
    //   next: (params) => {
    //     this.client = params.client;
    //     this.mergeFrom = params.mergeFrom;
    //   },
    // });
    // this.client = this.navParams.get('client');
    // this.mergeFrom = this.navParams.get('mergeFrom');


  }

  public ngOnInit() {
    
    if (this.mergeFrom.getFirstName()) {
      this.mergeFromFirstName = this.mergeFrom.getFirstName();
    }

    if (this.mergeFrom.getLastName()) {
      this.mergeFromLastName = this.mergeFrom.getLastName();
    }

    if (this.mergeFrom.getEmail()) {
      this.mergeFromEmail = this.mergeFrom.getEmail();
    }

    if (this.mergeFrom.getPhone1()) {
      this.mergeFromPhone1 = this.mergeFrom.getPhone1();
    }

    if (this.mergeFrom.getPhone2()) {
      this.mergeFromPhone2 = this.mergeFrom.getPhone2();
    }

    if (this.mergeFrom.getWorkph()) {
      this.mergeFromWorkPh = this.mergeFrom.getWorkph();
    }

    if (this.mergeFrom.getAddress1()) {
      this.mergeFromAddress1 = this.mergeFrom.getAddress1();
    }

    if (this.mergeFrom.getAddress2()) {
      this.mergeFromAddress2 = this.mergeFrom.getAddress2();
    }

    if (this.mergeFrom.getCity()) {
      this.mergeFromCity = this.mergeFrom.getCity();
    }

    if (this.mergeFrom.getProvince()) {
      this.mergeFromProvince = this.mergeFrom.getProvince();
    }

    if (this.mergeFrom.getPostal()) {
      this.mergeFromPostal = this.mergeFrom.getPostal();
    }

    if (this.mergeFrom.getNotes()) {
      this.mergeFromNotes = this.mergeFrom.notes;
    }

    this.modal =
      this.navParams.get('modal') !== undefined
        ? this.navParams.get('modal')
        : false;
    this.submitAttempt = false;
    this.isLoading = false;

    // localStorage.setItem('emailCheckerClientID', (this.client.getID()) ? this.client.getID() + '' : 'null');
    // this.clientService.setEmailCheckerClientID(this.client.getID() ? this.client.getID() : undefined);

    this.salon = this.userService.getSalon().clone();
    const countryID = this.salon.getCountry().id;

    // form controls
    this.firstName = new UntypedFormControl(
      this.client.getFirstName(),
      Validators.compose([Validators.required, Validators.maxLength(30)])
    );
    this.lastName = new UntypedFormControl(
      this.client.getLastName(),
      Validators.maxLength(35)
    );
    this.email = new UntypedFormControl(
      this.client.getEmail(),
      Validators.compose([
        Validators.maxLength(100),
        CustomValidator.validateEmail,
      ])
    );
    this.phone1 = new UntypedFormControl(
      this.client.getPhone1(),
      Validators.compose([
        Validators.maxLength(20),
        CustomValidator.validatePhone(countryID)])
    );
    this.phone2 = new UntypedFormControl(
      this.client.getPhone2(),
      Validators.compose([
        Validators.maxLength(20),
        CustomValidator.validatePhone(countryID)])
    );
    this.workPh = new UntypedFormControl(
      this.client.getWorkph(),
      Validators.maxLength(20)
    );
    this.address1 = new UntypedFormControl(
      this.client.getAddress1(),
      Validators.maxLength(40)
    );
    this.address2 = new UntypedFormControl(
      this.client.getAddress2(),
      Validators.maxLength(40)
    );
    this.city = new UntypedFormControl(
      this.client.getCity(),
      Validators.maxLength(20)
    );
    this.province = new UntypedFormControl(
      this.client.getProvince(),
      Validators.maxLength(25)
    );
    this.postal = new UntypedFormControl(
      this.client.getPostal(),
      Validators.maxLength(25)
    );
    this.notes = new UntypedFormControl(this.mergeFrom.getNotes() ? this.client.getNotes() + "\n" + this.mergeFromNotes : this.client.getNotes());
    this.clientForm = this.formBuilder.group({
      firstName: this.firstName,
      lastName: this.lastName,
      email: this.email,
      phone1: this.phone1,
      phone2: this.phone2,
      workPh: this.workPh,
      address1: this.address1,
      address2: this.address2,
      city: this.city,
      province: this.province,
      postal: this.postal,
      notes: this.notes,
    });
  }

  public ionViewDidLoad() {
    // When creating a new client, auto-focus on the "First name" field
    // if (this.client && !this.client.id) {
    // setTimeout(() => {
    // this.firstNameInput.setFocus();
    // }, 150);
    // }
  }

  public hasEmail(): boolean {
    return (
      this.email.value !== undefined &&
      CustomValidator.isEmailValid(this.email.value)
    );
  }

  public hasPhone2(): boolean {
    return (
      this.phone2.value !== undefined &&
      CustomValidator.isPhoneValid(this.phone2.value)
    );
  }

  public onDismiss() {
    this.modalCtrl.dismiss()
  }

  public async onClientSave() {

    // if (1 === 1) {
    //   return;
    // }

    this.submitAttempt = true;

    if (this.clientForm.valid === false) {
      return;
    }

    const loader = await this.loadingCtrl.create({ spinner: 'crescent' });
    loader.present();

    this.client = this.client.setFirstName(this.firstName.value);
    this.client = this.client.setLastName(this.lastName.value);
    this.client = this.client.setEmail(this.email.value);
    this.client = this.client.setPhone1(this.phone1.value);
    this.client = this.client.setPhone2(this.phone2.value);
    this.client = this.client.setWorkPh(this.workPh.value);
    this.client = this.client.setAddress1(this.address1.value);
    this.client = this.client.setAddress2(this.address2.value);
    this.client = this.client.setCity(this.city.value);
    this.client = this.client.setProvince(this.province.value);
    this.client = this.client.setPostal(this.postal.value);
    this.client = this.client.setNotes(this.notes.value);
    this.clientService
      .saveClient(this.client, this.mergeFrom.getID())
      .subscribe({
        next: (client) => {
          this.client = client;

          const data: IClientMergeFormCallBackData = {
            client: client,
            action: 'save',
          };

          loader.dismiss().then(() => {
            this.modalCtrl.dismiss(this.client);
          });
        },
        error: (error) => {
          loader.dismiss().then(async () => {
            const alert = await this.alertCtrl.create(
              Utilities.getDefaultErrorMessageConfig()
            );
            alert.present();
          });
        },
      });
  }
}
